var React = require('react');

function IconCheckmarkOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.5 16.06l-3.75-3.75 1.06-1.06 2.69 2.69 5.69-5.69 1.06 1.06-6.75 6.75z","key":0}),React.createElement("path",{"d":"M12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zM12 21a9 9 0 110-18 9 9 0 010 18z","key":1})]);
}

IconCheckmarkOutline.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconCheckmarkOutline;

IconCheckmarkOutline.default = IconCheckmarkOutline;
